import {Button, Form, Input} from 'antd';
import {DeleteOutlined, PlusOutlined} from '@ant-design/icons';
import {AnnouncementIconUpload} from './AnnouncementIconUpload';
import styles from './fullScreenPopup.module.scss';

/**
 * Benefits shown on the full screen popup. Each benefit is a short label plus an
 * icon uploaded with the shared flow-builder IconEditor (presigned S3 upload).
 */
export const BenefitsSection = () => (
  <div className={styles.sectionCard}>
    <div className={styles.sectionHeader}>
      <h3>Features</h3>
      <span>
        Features shown on the popup. Each feature has an icon and a short label.
      </span>
    </div>
    <Form.List name="benefits">
      {(fields, {add, remove}) => (
        <div className={styles.benefitList}>
          {!fields.length ? (
            <p className={styles.emptyHint}>No features added yet.</p>
          ) : null}
          {fields.map(field => (
            <div key={field.key} className={styles.benefitRow}>
              <div className={styles.benefitHeader}>
                <span className={styles.benefitIndex}>
                  Feature {field.name + 1}
                </span>
                <Button
                  type="text"
                  danger
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={() => remove(field.name)}
                  aria-label="Remove feature">
                  Remove feature
                </Button>
              </div>
              <div className={styles.benefitBody}>
                <Form.Item
                  label="Icon"
                  name={[field.name, 'icon']}
                  className={styles.benefitIcon}
                  tooltip="Upload the icon shown next to this feature.">
                  <AnnouncementIconUpload />
                </Form.Item>
                <Form.Item
                  label="Label"
                  name={[field.name, 'label']}
                  className={styles.benefitLabel}
                  rules={[
                    {required: true, message: 'Feature label is required'},
                  ]}>
                  <Input placeholder="e.g. Unlimited access to premium reports" />
                </Form.Item>
              </div>
            </div>
          ))}
          <Button
            type="dashed"
            icon={<PlusOutlined />}
            onClick={() => add({icon: '', label: ''})}
            className={styles.addBenefitBtn}>
            Add feature
          </Button>
        </div>
      )}
    </Form.List>
  </div>
);
